document.addEventListener('DOMContentLoaded', () => {
  const mediaWrapper = document.querySelectorAll('.media-wrapper-main');

  mediaWrapper.forEach(media => {
    const audio_controls = media.querySelector('.audio-controls');
    const videoElement = media.querySelector('video');

    if (audio_controls && videoElement) {
      const playSvg = audio_controls.querySelector('.play-svg');
      const pauseSvg = audio_controls.querySelector('.pause-svg');

      if (playSvg && pauseSvg) {
        audio_controls.addEventListener('click', () => {
          videoElement.muted = !videoElement.muted;

          playSvg.classList.toggle('hidden');
          pauseSvg.classList.toggle('hidden');
        });
      }
    }
  });

  // Sound after first interaction.
  // Browsers block autoplay-with-sound: videos autoplay muted and audio can
  // only be enabled after a genuine user-activation gesture (scroll does NOT
  // count). On the first such gesture we unmute the VISIBLE Media video(s),
  // then remove the listeners so a later manual mute is never overridden.
  const INTERACTION_EVENTS = ['pointerdown', 'touchend', 'click', 'keydown'];

  const removeInteractionListeners = () => {
    INTERACTION_EVENTS.forEach(type =>
      document.removeEventListener(type, onFirstInteraction)
    );
  };

  const onFirstInteraction = (event) => {
    // If the gesture is on the speaker toggle itself, let the toggle handle
    // it (avoids unmute → immediate re-mute on that click).
    if (event && event.target && event.target.closest && event.target.closest('.audio-controls')) {
      removeInteractionListeners();
      return;
    }

    document.querySelectorAll('.media[data-sound-on-interaction]').forEach(section => {
      // String compare: dataset value "false" is truthy, so check explicitly.
      if (section.dataset.soundOnInteraction !== 'true') return;

      section.querySelectorAll('.media-wrapper-main').forEach(wrapper => {
        const video = wrapper.querySelector('video');
        if (!video) return;
        // Only the breakpoint currently displayed; hidden ones stay muted.
        if (video.offsetParent === null) return;

        video.muted = false;
        video.play().catch(() => {});

        // Sync the existing speaker toggle to the unmuted state.
        const controls = wrapper.querySelector('.audio-controls');
        if (controls) {
          const playSvg = controls.querySelector('.play-svg');
          const pauseSvg = controls.querySelector('.pause-svg');
          if (playSvg && pauseSvg) {
            playSvg.classList.remove('hidden');
            pauseSvg.classList.add('hidden');
          }
        }
      });
    });

    removeInteractionListeners();
  };

  INTERACTION_EVENTS.forEach(type =>
    document.addEventListener(type, onFirstInteraction)
  );
});
